import { gql } from '@apollo/client';

export const DELETE_ADDITIONAL_EXHIBITION_IMAGE = gql`
  mutation DeleteAdditionalExhibitionImage($id: Int!) {
    success: deleteAdditionalExhibitionImage(id: $id)
  }
`;
